module.exports = __webpack_public_path__ + "static/media/sola.a59de5f5.jpg";